// extracted by mini-css-extract-plugin
module.exports = {"cardbox":"cardbox--5c3Pv","title":"title--2JRJ8","ext":"ext--fVdL1","blank":"blank--3GGv0","moreBtn":"moreBtn--1Vef1"};